import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { ReportEnrolmentsPage } from './report-enrolments';

@NgModule({
  declarations: [
    ReportEnrolmentsPage,
  ],
  imports: [
    IonicPageModule.forChild(ReportEnrolmentsPage),
  ],
})
export class ReportEnrolmentsPageModule {}



// WEBPACK FOOTER //
// ./src/pages/report-enrolments/report-enrolments.module.ts